import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";

export default class EmailCountPromptController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    const params = Object.assign({}, options, $ctrl.options);
    $ctrl.count = params.count;
    $ctrl.bus = new ServiceBus();
    $ctrl.title = params.title || "Email Count...";
    $ctrl.from = $ctrl.$session.email;
    $ctrl.subject = "Stock Count - " + $ctrl.count.countName;
    $ctrl.message = "";
  }

  emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
  submit() {
    const $ctrl = this;
    $ctrl.emailSent = false;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "EmailReport?To=" +
        $ctrl.to +
        "&replyTo=" +
        $ctrl.from +
        "&reportName=QuickReport&displayName=" +
        $ctrl.count.countName +
        "&output=xlsx&QuickReportID=StockCountExceptions" +
        "&QuickReportName=StockCountExceptions" +
        "&Message=" +
        $ctrl.message +
        "&@ListId=" +
        $ctrl.count.listId +
        "&@CountId=" +
        $ctrl.count.id
    );

    location.href = url;
    $ctrl.$close();
  }
}
